/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Responses_RequiredInputs */

const es_co2_error_responses_required = /** @type {(inputs: Error_Responses_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falta responder un campo obligatorio del formulario.`)
};

/**

* @param {Error_Responses_RequiredInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_responses_required = /** @type {((inputs?: Error_Responses_RequiredInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Responses_RequiredInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_responses_required(inputs)
});